import React from 'react'
import { Button as HdsButton } from '@postenbring/hedwig-react'

export const Button = ({href, size, variant, buttonText, buttonTarget }) => {

    return (
        <HdsButton asChild variant={variant} size={size} target={buttonTarget}>
            <a href={href} className="hds-mb-24-32">
                {buttonText}
            </a>
        </HdsButton>
    )
}
